import { Dispatch } from "redux";
import { fetchError, fetchStart, fetchSuccess } from "./Common";
import jwtAxios from "../../@crema/services/auth/jwt-auth";
import { AppActions } from "types";
import {  CREATE_PLAN, CREATE_PLAN_GROUP, CREATE_PLAN_PAGE, DELETE_PAGE_Plan, DELETE_PLAN, GET_Category, GET_PAGE_Plan, GET_PageMapping, GET_Plan,  Plans_Count_Dashboard,  SET_Category_DATA,  SET_PageMapping_DATA,  SET_Plan_DATA, UPDATE_PLAN } from "types/actions/planMaster.action";
import { AxiosResponse } from "axios";
import { SET_CITY_DATA } from "types/actions/Master.action";
import { PlanData } from "types/models/planMaster/planMasterApp";


export const getPlan = (
  search: string,
  offset: number,
  limit: number,
  field: string = ""
) => {
  return (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchStart());

    const params: any = {
      offset,
      limit,
    };

    if (search) {
      params.searchTerm = search;

      if (field && field !== "all") {
        params.fields = field;
      } else {
        
        params.fields = "planName,planGroupCode,planDuration,rentExclTax,popPlan";
      }
    }

    jwtAxios
      .get("plans", { params })
      .then((response) => {
        if (response.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: GET_Plan, payload: response.data.data });
        } else {
          dispatch(fetchError("Something went wrong, Please try again!"));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};


export const createPlanGroupCode = (payload: any, onSuccess?: () => void) => {
  return (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchStart());
    jwtAxios
      .put("/plans/cms/updateplangroup", payload)
      .then((response) => {
        if (response.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: CREATE_PLAN_GROUP, payload: response.data.data });
          if (onSuccess) onSuccess();
        } else {
          dispatch(fetchError("Something went wrong, Please try again!"));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const getPlangetPlansByGroupCode = () => {
  return (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchStart());
    jwtAxios
      .get("plans/cms/groupedplans")
      .then((response) => {
        if (response.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: GET_PAGE_Plan, payload: response.data.data });
        } else {
          dispatch(fetchError("Something went wrong, Please try again!"));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};


export const createPlan = (payload: any) => {
  return (dispatch: Dispatch<AppActions>): Promise<AxiosResponse<any>> => {
    dispatch(fetchStart());

    return jwtAxios
      .post(`/plans`, payload)
      .then((response) => {
        if (response.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: CREATE_PLAN, payload: response.data });
        } else {
          dispatch(fetchError("Failed to create plan"));
        }
        return response; 
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
        return Promise.reject(error); 
      });
  };
};
export const updatePlan = (planId: any, payload) => {
  return (dispatch: Dispatch<AppActions>): Promise<AxiosResponse<any>> => {
    dispatch(fetchStart());

    return jwtAxios
      .put(`/plans/${planId}`, payload)
      .then((response) => {
        if (response.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: UPDATE_PLAN, payload: response.data });
        } else {
          dispatch(fetchError("Failed to create plan"));
        }
        return response; 
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
        return Promise.reject(error); 
      });
  };
};

export const deletePlan = (plan: PlanData) => {
  return (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchStart());
    return jwtAxios
      .delete(`/plans/${plan.planId}`)
      .then((response) => {
        if (response.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: DELETE_PLAN, payload: plan.planId });
          return response.data;
        } else {
          throw new Error("Failed to delete user");
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
        throw error;
      });
  };
};


export const getPlans = (search: string, page: number) => {
  return (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchStart());
    jwtAxios
      .get("plans", { params: { search, page } })         
      .then((response) => {
        if (response.status === 200 && response.data.status === "success") {
          dispatch(fetchSuccess());
          dispatch({ type: GET_Plan, payload: response.data.data });
        } else {
          dispatch(fetchError("Something went wrong, please try again!"));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const getPlanDetail = (id: number | string) => {
  return (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchStart());
    jwtAxios
      .get(`plans/${id}`)
      .then((response) => {
        if (response.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: SET_Plan_DATA,payload: response.data.data });
        } else {
          dispatch(fetchError("Something went wrong, Please try again!"));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

// Category Actions 
export const getCategory = (search: string, page: number) => {
  return (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchStart());
    jwtAxios
      .get("/api/ecommerce/category", {
        params: { search, page },
      })
      .then((data) => {
        if (data.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: GET_Category, payload: data.data });
        } else {
          dispatch(fetchError("Something went wrong, Please try again!"));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const getCategoryDetail = (sNo: number | string) => {
  return (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchStart());
    jwtAxios
      .get("/api/ecommerce/Category/get", {
        params: { sNo: sNo },
      })
      .then((data) => {
        if (data.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: SET_Category_DATA, payload: data.data });
        } else {
          dispatch(fetchError("Something went wrong, Please try again!"));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
// PageMapping Actions 
export const getPageMapping = (search: string, page: number) => {
  return (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchStart());
    jwtAxios
      .get("/api/ecommerce/pageMapping", {
        params: { search, page },
      })
      .then((data) => {
        if (data.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: GET_PageMapping, payload: data.data });
        } else {
          dispatch(fetchError("Something went wrong, Please try again!"));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const getPageMappingDetail = (sNo: number | string) => {
  return (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchStart());
    jwtAxios
      .get("/api/ecommerce/PageMapping/get", {
        params: { sNo: sNo },
      })
      .then((data) => {
        if (data.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: SET_PageMapping_DATA, payload: data.data });
        } else {
          dispatch(fetchError("Something went wrong, Please try again!"));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const fetchCities = (search: string = "", page: number = 1) => {
  return async (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchStart());
    try {
      const response = await jwtAxios
      .get(`/cities?search=${search}&page=${page}`);
      dispatch(fetchSuccess());
      dispatch({
        type: SET_CITY_DATA,
        payload: response.data.data,
      });
      return response; 
    } catch (error: any) {
      dispatch(fetchError(error.message));
      throw error;
    }
  };
};

export const createPlanPage = (payload: any) => {
  return (dispatch: Dispatch<AppActions>): Promise<AxiosResponse<any>> => {
    dispatch(fetchStart());

    return jwtAxios
      .post(`/pages/load-plans`, payload)
      .then((response) => {
        if (response.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: CREATE_PLAN_PAGE, payload: response.data });
        } else {
          dispatch(fetchError("Failed to create plan"));
        }
        return response; 
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
        return Promise.reject(error); 
      });
  };
};

export const getPlanPageDetail = (planid: number | string) => {
  return async (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchStart());
    try {
      const response = await jwtAxios.get(`/pages/planpagemap?planid=${planid}`);
      if (response.status === 200) {
        dispatch(fetchSuccess());
        dispatch({
          type: SET_PageMapping_DATA,
          payload: response.data,
        });
        return response;
      } else {
        dispatch(fetchError("Something went wrong, Please try again!"));
        throw new Error("Request failed");
      }
    } catch (error: any) {
      dispatch(fetchError(error.message));
      throw error;
    }
  };
};

export const deletePlanPage = (plan: PlanData) => {
  return (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchStart());
    return jwtAxios
      .delete(`/pages/${plan.planGroupCode}`)
      .then((response) => {
        if (response.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: DELETE_PAGE_Plan, payload: plan.planId });
          return response.data;
        } else {
          throw new Error("Failed to delete user");
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
        throw error;
      });
  };
};
export const getPlansCountDashboard = () => {
  return async (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchStart());
    try {
      const response = await jwtAxios.get(`/plans/getDashboardPlansCount`);
      if (response.status === 200) {
        dispatch(fetchSuccess());
        dispatch({
          type: Plans_Count_Dashboard,
          payload: response.data.data,
        });
        return response;
      } else {
        dispatch(fetchError("Something went wrong, Please try again!"));
        throw new Error("Request failed");
      }
    } catch (error: any) {
      dispatch(fetchError(error.message));
      throw error;
    }
  };
};